export default __webpack_public_path__ + "static/media/sussy.58bb450f.png";